import { useQuery } from "@tanstack/react-query";
import { Post } from "../../../utils/apiService";
import {
  GetAllUsersBody,
  GetDetailCodeByIdParams,
  GetUserByIdPBody,
  GetVisitPurposeByIdBody,
} from "../interface";

export const FETCH_USER_DETAILS_KEYS = {
  FETCH_USER_DETAILS: "FETCH_USER_DETAILS",
  FETCH_USER_PROFILE_DETAILS: "FETCH_USER_PROFILE_DETAILS",
  FETCH_ALL_USERS: "FETCH_ALL_USERS",
  FETCH_USER_BY_ID: "FETCH_USER_BY_ID",
  FETCH_DETAIL_CODE_BY_ID: "FETCH_DETAIL_CODE_BY_ID",
  FETCH_VISIT_PURPOSE_BY_ID: "FETCH_VISIT_PURPOSE_BY_ID",
  FETCH_LOCATION_BY_ID: "FETCH_LOCATION_BY_ID",
  FETCH_CAPTCHA: "FETCH_CAPTCHA",
  FETCH_PROFILE: "FETCH_PROFILE"
};

const getProfileAction = async () => {
  return Post({
    url: "/api/EditProfile/GetProfile",
  });
};

export const useGetProfile = () => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_PROFILE],
    queryFn: () => getProfileAction(),
  });
};

const getCaptchaAction = async () => {
  return Post({
    url: "/api/Login/GetVMSCaptchaParams",
    isCredentialInclude: true,
  });
};

export const useGetCaptcha = () => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_CAPTCHA],
    queryFn: () => getCaptchaAction(),
  });
};

const getAllUsersAction = async (body: GetAllUsersBody) => {
  return Post({
    url: "/api/Users/GetAll",
    body,
  });
};

export const useGetAllUsers = (body: GetAllUsersBody) => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_ALL_USERS, body],
    queryFn: () => getAllUsersAction(body),
  });
};

const getUserByIdAction = async (body: GetUserByIdPBody) => {
  return Post({
    url: "/api/Users/GetById",
    body,
  });
};

export const useGetUserById = (body: GetUserByIdPBody) => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_USER_BY_ID, body],
    queryFn: () => getUserByIdAction(body),
    enabled: !!body.encryptedId,
  });
};

const getDetailCodeByIdAction = async (params: GetDetailCodeByIdParams) => {
  return Post({
    url: "/api/SystemCodes/GetByIdDetailCodes",
    params,
  });
};

export const useGetDetailCodeById = (params: GetDetailCodeByIdParams) => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_DETAIL_CODE_BY_ID, params],
    queryFn: () => getDetailCodeByIdAction(params),
    enabled: !!params.id,
  });
};

const getVisitPurposeByIdAction = async (body: GetVisitPurposeByIdBody) => {
  return Post({
    url: "/api/VisitPurposes/GetById",
    body,
  });
};

export const useGetVisitPurposeById = (body: GetVisitPurposeByIdBody) => {
  return useQuery({
    queryKey: [FETCH_USER_DETAILS_KEYS.FETCH_VISIT_PURPOSE_BY_ID, body],
    queryFn: () => getVisitPurposeByIdAction(body),
    enabled: !!body.encryptedId,
  });
};
